import styled from 'styled-components';
import { theme } from '../../styles/GlobalStyles';

export const Wrapper = styled.footer`
  border: 1px solid #e5e5e5;
  border-top: 0;

  .footer-top {
    max-width: 2500px;
    width: 100%;

    img {
      width: 100%;
    }
  }

  ul {
    list-style: none;
    padding: 0px;
    margin: 0px;
  }
  li {
    margin: 0px;
  }
  @media(max-width: 1900px) {
    .footer-top {
      width: 1900px;
    }
  }
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2.438rem 0px;

  @media (min-width: 733px) {
    flex-direction: row;
  }
`;

export const BrandWrapper = styled.div`
  min-width: 7rem;
`;

export const MenusWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  @media (min-width: 733px) {
    margin-left: auto;
  }

  @media (min-width: 990px) {
    margin-right: 0;
  }
`;

export const Menu = styled.div`
  display: inline-block;
  flex: 50%;

  &:nth-child(-n + 2) {
    margin-bottom: 1.9375rem;
  }

  h3 {
    margin-bottom: 0.68rem;
    font-size: 1.25rem;
    line-height: 1.5;
  }

  a {
    text-transform: capitalize;
    font-size: 0.875rem;
  }

  li:not(:last-child) {
    margin-bottom: 0.35rem;
  }

  @media (min-width: 733px) {
    flex: unset;
    margin-bottom: unset;

    &:not(:last-child) {
      margin-right: 1.875rem;
    }
  }

  @media (min-width: 990px) {
    &:not(:last-child) {
      margin-right: 2.375rem;
    }
  }
`;

export const LineWrapper = styled.div`
  background-color: ${theme.background.lightGray};
`;

export const Line = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 0.87rem;
  padding: 0.75rem 0px;

  div {
    margin-bottom: 0.75rem;
    display: inline-block;
  }

  ul {
    display: flex;
    justify-content: center;
  }

  li:not(:last-child) {
    margin-right: 1.25rem;
  }

  @media (min-width: 650px) {
    flex-direction: row;
    position: relative;

    div {
      margin-bottom: 0px;
    }
    ul {
      position: absolute !important;
      top: 5px !important;
      right: 0;
      left: auto !important;
    }
  }
`;
